<pla-main-nav-chips></pla-main-nav-chips>
<div class="lg-root">
  <main class="lg-wrap">
    <nav class="lg-crumb" aria-label="Breadcrumb"><a routerLink="/">Home</a> › Privacy Policy</nav>
    <p class="lg-eyebrow">Legal</p>
    <h1 class="lg-h1">Privacy Policy</h1>
    <p class="lg-updated">Last updated: 1 November 2026</p>

    <div class="lg-body">
      <p class="lg-lede">
        At PlateX, we respect your privacy and are committed to protecting your personal information. This Privacy Policy
        explains how we collect, use, store and protect your data when you visit PlateX.co.uk, create an account or use
        our services.
      </p>

      <section class="lg-section">
        <h2 class="lg-h2">1. Who we are</h2>
        <p>
          PlateX is a UK online platform that helps users search, discover, compare and track private vehicle
          registrations.
        </p>
        <p>
          For questions about your personal data or this Privacy Policy, please contact us at
          <a href="mailto:info@platex.co.uk">info&#64;platex.co.uk</a>.
        </p>
      </section>

      <section class="lg-section">
        <h2 class="lg-h2">2. Information we collect</h2>
        <p>Depending on how you use PlateX, we may collect:</p>
        <ul>
          <li>
            <b>Account information:</b> Your name, email address and information provided when registering or managing
            your account.
          </li>
          <li>
            <b>Search and activity information:</b> Registration searches, saved plates, alerts, preferences and
            interactions with our services.
          </li>
          <li>
            <b>Technical information:</b> IP address, browser type, device information, pages visited and other website
            usage information.
          </li>
          <li><b>Communications:</b> Information you provide when contacting us or submitting enquiries.</li>
          <li>
            <b>Information from connected services:</b> Limited information received when you choose to sign in using a
            third-party service, such as Facebook or Google.
          </li>
        </ul>
      </section>

      <section class="lg-section">
        <h2 class="lg-h2">3. How we use your information</h2>
        <p>We use personal information to:</p>
        <ul>
          <li>Provide and maintain PlateX services.</li>
          <li>Manage user accounts, saved searches and registration alerts.</li>
          <li>Personalise and improve search results and website functionality.</li>
          <li>Send notifications you have requested.</li>
          <li>Respond to enquiries and provide support.</li>
          <li>Monitor website performance, prevent misuse and maintain security.</li>
          <li>Meet applicable legal and regulatory obligations.</li>
        </ul>
        <p>
          We process personal information only where we have an appropriate lawful basis, including providing requested
          services, complying with legal obligations, pursuing legitimate interests or obtaining consent where required.
        </p>
      </section>

      <section class="lg-section">
        <h2 class="lg-h2">4. Cookies and analytics</h2>
        <p>
          PlateX may use cookies and similar technologies to operate the website, remember preferences and understand how
          visitors use our services.
        </p>
        <p>
          Essential cookies support core functionality. Optional analytics or other non-essential cookies are used subject
          to applicable consent requirements.
        </p>
        <p>
          You can review or change your choices through the
          <button type="button" class="lg-link" (click)="openCookiePreferences()">Update cookies preferences</button>
          link in our website footer.
        </p>
      </section>

      <section class="lg-section">
        <h2 class="lg-h2">5. Sharing your information</h2>
        <p>
          PlateX operates as a registration search and comparison platform. When you choose to visit a registration
          provider or dealer, you may be redirected to an external website.
        </p>
        <p>We do not sell your personal information to registration dealers.</p>
        <p>
          We may share limited information with trusted technology and service providers where necessary to operate
          PlateX, subject to appropriate safeguards, or where required by law.
        </p>
        <p>External websites have their own privacy policies, which we encourage you to review.</p>
      </section>

      <section class="lg-section">
        <h2 class="lg-h2">6. How long we keep your information</h2>
        <p>
          We retain personal information only for as long as reasonably necessary for the purposes described in this
          policy, including maintaining your account, providing requested services, meeting legal obligations and
          resolving disputes.
        </p>
        <p>Retention periods depend on the type of information and the reason it was collected.</p>
      </section>

      <section class="lg-section">
        <h2 class="lg-h2">7. Your rights</h2>
        <p>Under applicable UK data protection law, you may have the right to:</p>
        <ul>
          <li>Access personal information we hold about you.</li>
          <li>Request correction of inaccurate information.</li>
          <li>Request deletion of your personal information.</li>
          <li>Object to or restrict certain processing.</li>
          <li>Request transfer of eligible personal information.</li>
          <li>Withdraw consent where processing is based on consent.</li>
        </ul>
        <p>To exercise your rights, email <a href="mailto:info@platex.co.uk">info&#64;platex.co.uk</a>.</p>
        <p>
          You may also raise a concern with the Information Commissioner's Office (ICO) at
          <a href="https://www.ico.org.uk" target="_blank" rel="noopener">www.ico.org.uk</a>.
        </p>
      </section>

      <section class="lg-section">
        <h2 class="lg-h2">8. Security</h2>
        <p>
          We take reasonable technical and organisational measures to protect personal information against unauthorised
          access, loss, misuse or disclosure.
        </p>
        <p>However, no online service can guarantee absolute security.</p>
      </section>

      <section class="lg-section">
        <h2 class="lg-h2">9. Changes to this policy</h2>
        <p>
          We may update this Privacy Policy to reflect changes to our services, legal requirements or data processing
          practices.
        </p>
        <p>The latest version will be published on this page with an updated revision date.</p>
      </section>

      <section class="lg-contact">
        <h2 class="lg-h2">10. Contact us</h2>
        <p>For privacy enquiries or requests concerning your personal information:</p>
        <dl>
          <dt>Email</dt>
          <dd><a href="mailto:info@platex.co.uk">info&#64;platex.co.uk</a></dd>
          <dt>Website</dt>
          <dd><a href="https://www.platex.co.uk">www.platex.co.uk</a></dd>
        </dl>
      </section>
    </div>
  </main>
</div>
